import { useMemo } from "react"
import { useSelector } from "react-redux"
import { getTableColumns } from "store/selectors/templateSettings.js"

const useHiddenRows = () => {
    const settings = useSelector(getTableColumns)

    const columnVisibility = useMemo(() => {
        const columnVisibility = settings.reduce((acc, item)=>{
            const key = item.metaData.name
            const value = item.metaData.isHiddenColumn
            return {...acc, [key]: !value}
        }, {})
    
        return columnVisibility
      }, [settings])

      const settingsColumns =  useMemo(() => {
        const settingsColumns = []
        settings.forEach((item) => {
            const key = item.metaData.name
            settingsColumns.push(key)
        })
    
        return settingsColumns
      }, [settings])

      return {settingsColumns, columnVisibility}
}

export default useHiddenRows